export var hasMarginProps = function (props) {
    var isUndefined = function (value) { return value === undefined; };
    return (!isUndefined(props.margin) ||
        !isUndefined(props.marginX) ||
        !isUndefined(props.marginY) ||
        !isUndefined(props.marginTop) ||
        !isUndefined(props.marginBottom) ||
        !isUndefined(props.marginLeft) ||
        !isUndefined(props.marginRight));
};
export var MarginProps = function (props) {
    var MarginObject = {};
    if (props && props.margin !== undefined)
        MarginObject.margin = props.margin;
    if (props && props.marginX !== undefined)
        MarginObject.marginLeft = props.marginX;
    if (props && props.marginX !== undefined)
        MarginObject.marginRight = props.marginX;
    if (props && props.marginY !== undefined)
        MarginObject.marginTop = props.marginY;
    if (props && props.marginY !== undefined)
        MarginObject.marginBottom = props.marginY;
    if (props && props.marginTop !== undefined)
        MarginObject.marginTop = props.marginTop;
    if (props && props.marginBottom !== undefined)
        MarginObject.marginBottom = props.marginBottom;
    if (props && props.marginLeft !== undefined)
        MarginObject.marginLeft = props.marginLeft;
    if (props && props.marginRight !== undefined)
        MarginObject.marginRight = props.marginRight;
    return MarginObject;
};
